module.exports = __webpack_public_path__ + "media/images/my_trailhead/looking_for_salesforce_trails-c19c17c3325774d57cab2f0931b507ed.svg";